/* eslint-disable multiline-ternary */
import React from 'react'
import { View, Text, Image } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import closeIcon from '../../../../images/illustrations/objective-not-met.png'
import { themeConfig } from '../../config/theme.config'
import TableGrid from './TableGrid'
import LeftSectionTitle from './LeftSectionTitle'
import RightSectionTitle from './RightSectionTitle'
import BoxLeft from './BoxLeft'
import BoxRight from './BoxRight'
import SectionTitle from './SectionTitle'

const ObjectivesMatrix = ({ reportTickImgDataUrl }) => {
  const parent = {
    width: '100%',
    maxWidth: '100%',
    textAlign: 'center',
    marginTop: 15
  }
  const scoringSummaryFields = [
    'Score',
    'Main Street',
    'Urban or Walkable Thoroughfares',
    'Small Town Hamlet or Village Commercial',
    'Suburban Corridors',
    'Rural'
  ]
  const rows = [
    ['Score 1 (Highest)', true, true, true, true, true],
    ['Score 2', true, true, true, true, true],
    ['Score 3', false, false, false, false, true],
    ['Score 4 (Lowest)', false, false, false, false, false]
  ]

  return (
    <View style={[parent]} debug={false} fixed={true}>
      <TableGrid>
        {scoringSummaryFields.map((field, i) => {
          if (i === 0) {
            return (
              <LeftSectionTitle
                leftTitle={field}
                width="16.6%"
                key={`${field}_${i}_report`}
              />
            )
          } else {
            return (
              <RightSectionTitle
                rightTitle={field}
                width="16.6%"
                key={`${field}_${i}_report`}
              />
            )
          }
        })}
      </TableGrid>
      {rows.map((row, rowIndex) => {
        return (
          <TableGrid key={`${row[0]}_report`}>
            {row.map((cell, index) => {
              if (index === 0) {
                return (
                  <BoxLeft
                    value={cell}
                    width="16.6%"
                    key={`${cell}_report`}
                    textAlign="left"
                    color={themeConfig.semcogBlue1}
                  />
                )
              } else {
                return (
                  <BoxRight
                    index={rowIndex}
                    value={cell ? '✔️' : ''}
                    width="16.6%"
                    key={`${cell}_report`}
                    backgroundColor={cell ? '#12396A' : 'none'}
                    objectiveMet={cell}
                    color={themeConfig.semcogBlue1}
                    reportTickImgDataUrl={reportTickImgDataUrl}
                  />
                )
              }
            })}
          </TableGrid>
        )
      })}
      <View
        style={{
          display: 'flex',
          gap: 10,
          marginTop: 20,
          fontSize: 11,
          padding: '0pt 5pt',
          fontFamily: 'Roboto'
        }}
      >
        <View style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
          <BoxRight
            value="YES"
            width="10.6%"
            key="_report"
            index={0}
            objectiveMet={true}
          />
          <Text
            style={{
              alignSelf: 'center',
              fontFamily: 'Roboto',
              fontStyle: 'italic',
              color: themeConfig.lightTextColor
            }}
          >
            Meets or exceeds objective
          </Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
          <BoxLeft
            value={''}
            width="10.6%"
            key="_report"
            index={0}
            objectiveMet={false}
          />
          <Text
            style={{
              alignSelf: 'center',
              fontFamily: 'Roboto',
              fontStyle: 'italic',
              color: themeConfig.lightTextColor
            }}
          >
            Needs improvement
          </Text>
        </View>
      </View>
    </View>
  )
}

export default ObjectivesMatrix

ObjectivesMatrix.propTypes = {}
